export default __webpack_public_path__ + "static/media/arkansas.bc1cd5d6.jpg";